<template>
  <div class="banner">
    <div class="banner-prev" @click="prev"></div>
    <div class="banner-next" @click="next"></div>
    <transition-group tag="ul" name="banner-trans" class="banner-container">
      <li class="image-container"
      v-for="(item, index) in banners"
      v-show="index === imgIndex"
      :key="index">
        <a :href="item.url" target="_blank">
          <img :src="item.src" />
        </a>
      </li>
    </transition-group>
    <div class="banner-points">
      <a class="banner-point" @click="jump(index)" :class="{'active': index === imgIndex}" v-for="(item, index) in banners.length" :key="index"></a>
    </div>
  </div>
</template>

<script>
// 轮播图组件：用于展示首页顶部轮播图片，支持自动播放和手动切换
export default {
  data () {
    return {
      imgIndex: 0,
      timer: '',
    }
  },
  props: ['banners'],
  methods: {
    next () {
      const lastPage = this.banners.length - 1;
			if (this.imgIndex < lastPage) {
				this.imgIndex += 1;
			} else {
				this.imgIndex = 0;
			}
    },
    prev () {
      const lastPage = this.banners.length - 1;
			if (this.imgIndex > 0) {
				this.imgIndex -= 1;
			} else {
				this.imgIndex = lastPage;
			}
    },
    play () {
			clearInterval(this.timer);
			this.timer = setInterval(() => {
				this.next();
			}, 5000);
    },
    jump (index) {
      this.imgIndex = index;
    }
  },
  mounted () {
    this.play();
  }
}
</script>

<style lang="less">
.banner {
  position: relative;
  margin-top: 0;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 14px 30px rgba(108, 123, 255, 0.18);
  border: 1px solid rgba(108, 123, 255, 0.3);
  .banner-prev {
    position: absolute;
    top: 50%;
    width: 41px;
    height: 69px;
    margin-top: -35px;
    z-index: 5;
    cursor: pointer;
    outline: none;
    background: url(../../assets/image/icon-slides.png) no-repeat -84px 50%;
    left: 234px;
    right: auto;
    &:hover {
      background: url(../../assets/image/icon-slides.png) no-repeat 0px 50%;
    }
  }

  .banner-next {
    position: absolute;
    top: 50%;
    width: 41px;
    height: 69px;
    margin-top: -35px;
    z-index: 5;
    cursor: pointer;
    outline: none;
    background: url(../../assets/image/icon-slides.png) no-repeat -125px 50%;
    right: 0;
    left: auto;
    &:hover {
      background: url(../../assets/image/icon-slides.png) no-repeat -43px 50%;
    }
  }

  .banner-points {
    position: absolute;
    display: inline-block;
    width: 400px;
    left: auto;
    right: 30px;
    bottom: 20px;
    text-align: right;
    transform: translateZ(0);
    z-index: 10;
    .banner-point {
      display: inline-block;
      width: 10px;
      height: 10px;
      border: 2px solid rgba(255, 255, 255, 0.7);
      border-radius: 10px;
      overflow: hidden;
      background: rgba(108, 123, 255, 0.5);
      opacity: 1;
      margin: 0 4px;
      cursor: pointer;
      &:hover {
        background: rgba(0, 212, 255, 0.7);
        border-color: rgba(0, 212, 255, 0.7);
      }
    }

    .active {
      background: rgba(255, 123, 213, 0.7);
      border-color: rgba(255, 123, 213, 0.7);
    }
  }

  .banner-container {
    width: 100%;
    height: 460px;
    overflow: hidden;
    .image-container {
      width: 100%;
      height: 100%;
      a {
        display: block;
        width: 100%;
        height: 100%;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }
}

.banner::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(0, 212, 255, 0.18) 0%, rgba(108, 123, 255, 0.12) 45%, rgba(255, 123, 213, 0.14) 100%);
  pointer-events: none;
}

// 轮播图
.banner-trans-enter-active {
  transition: all 0.1s ease-in-out;
  opacity: 1;
}

.banner-trans-leave-active {
  opacity: 0;
}

.banner-trans-enter,
.banner-trans-leave-to {
  opacity: 0;
}

.banner-trans-enter-to,
.banner-trans-leave {
  opacity: 1;
}
</style>
